// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__188G4","title":"BackImages_title__1W-Ys","images":"BackImages_images__2o2rE"};